<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Department" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
        <label *ngIf="level > 3">Add Detail</label>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchEquipment($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-content *ngIf="level === 1 && deptList">
        <ion-row class="ion-padding-horizontal ion-padding-top">
            <ion-col size="4" *ngFor="let d of deptList | filterDepartment: queryText; index as i;" (click)="refineToGroup(d)" class="ion-text-center">
                <ion-badge id="notifications-badge" *ngIf="d.count > 0">
                    {{d.count}}
                </ion-badge>
                <div class="circle" [style.background-color]="pickColor(i)">
                    {{d.descr.length < 3 ? d.descr : d.descr.substr(0, 3)}}
                </div>
                <ion-label class="smalltext ion-text-center">
                    {{d.descr}}
                </ion-label>
            </ion-col>
        </ion-row>
    </ion-content>

    <ion-content *ngIf="level === 2">
        <h4 class="ion-padding-start">Select Equipment</h4>
        <ion-list>
            <ion-item *ngFor="let equip of equipList">
                <ion-label class="ion-text-wrap">{{equip.description}}</ion-label>
                <ion-input type="number" [(ngModel)]="equip.qty" placeholder="0" (click)="$event.target.select()"
                           class="ion-text-end"></ion-input>
            </ion-item>
        </ion-list>
    </ion-content>

</ion-content>
